import React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import MenuItem from '@material-ui/core/MenuItem';
import { withStyles } from '@material-ui/core';
import Help from '@material-ui/icons/Help';
import { Link } from 'react-router-dom';
import { neutralWhite, primaryNavy } from 's1-ui/themes/sovos-colors';
import { SovosToolbar, SovosToolbarActions, SovosToolbarMoreMenu } from 's1-ui/sovos-toolbar';
// import SupplierDropdown from './SupplierDropdown';
import { pageWidth } from '../../constants';
import { removeToken } from '../../services/auth.service';


const styles = {
  title: {
    color: neutralWhite,
    fontSize: '18px',
    fontWeight: 300,
    marginLeft: '20px',
    flexGrow: 1
  },
  toolBar: {
    backgroundColor: primaryNavy,
    maxWidth: pageWidth,
    width: 'calc(100% - 48px)',
    margin: 'auto'
  },
  iconButton: {
    color: neutralWhite
  },
  appBar: {
    backgroundColor: primaryNavy
  },
  logo: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  }
};

export const UnstyledTitleBar = ({ classes, history }) => (
  <div className="CCP__TitleBar__base">
    <AppBar
      position="static"
      classes={ { root: classes.appBar } }
    >
      <SovosToolbar classes={ { root: classes.toolBar } }>
        <Link to="/" style={ { textDecoration: 'none' } }>
          <div className={ classes.logo }>
            <Typography className={ classes.title }>
              SOVOS SHIPCOMPLIANT CARRIER COMPLIANCE
            </Typography>
          </div>
        </Link>
        <SovosToolbarActions>
          <IconButton
            classes={ { root: classes.iconButton } }
            onClick={ () => history.push('/help') }
          >
            <Help />
          </IconButton>
          <SovosToolbarMoreMenu color={ neutralWhite }>
            <MenuItem
              onClick={ () => history.push('/settings') }
            >Settings
            </MenuItem>
            <MenuItem
              onClick={ () => { removeToken(); history.push('/login'); } }
            >Logout
            </MenuItem>
          </SovosToolbarMoreMenu>
        </SovosToolbarActions>
      </SovosToolbar>
    </AppBar>
  </div>
);


UnstyledTitleBar.propTypes = {
  classes: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
};

export default withStyles(styles)(UnstyledTitleBar);
